import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import App from '@/app.vue'
import './index.css'
import './assets/tema.css'
import router from '@/router'
import { registerLayouts } from '@/layouts/register'
import { registerAuthDirectives } from '@/directives/auth'
import { config, isDevelopment, buildInfo } from '@/config/env'
import i18n from '@/locales'
// @ts-ignore
import vClickOutside from 'click-outside-vue3'
import { createYmaps } from 'vue-yandex-maps'
import Toast, { PluginOptions, POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import CopyBtn from '@/components/ui/CopyBtn.vue'
import gs from '@/components/ui/gs.vue'

if (isDevelopment && config.enableDebug) {
  console.group('🚀 Application Starting')
  console.log('Environment:', config.nodeEnv)
  console.log('Version:', buildInfo.version)
  console.log('API Base URL:', config.apiBaseUrl)
  console.groupEnd()
}

const pinia = createPinia()
pinia.use(({ store }) => {
  store.router = markRaw(router)
})

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vClickOutside)
registerLayouts(app)
registerAuthDirectives(app)
app.use(
  createYmaps({
    apikey: '9c9f32d3-c925-4121-8673-5c69d9b4f7eb',
  })
)

app.component('CopyBtn', CopyBtn)
app.component('gs', gs)

app.config.errorHandler = (err, instance, info) => {
  console.error('Global error:', err, info, 'Instance:', instance)

  if (config.enableErrorReporting && !isDevelopment) {
  }
}

app.mount('#app')

app.config.globalProperties.$dateFormat = (date: Date | string | undefined | null) => {
  if (!date) return '-'
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return date.toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
}

app.config.globalProperties.$dateTimeFormat = (date: Date | string | undefined | null) => {
  if (!date) return '-'
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return date.toLocaleString('ru-RU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

app.config.globalProperties.$currencyFormat = (value: number | string | undefined | null) => {
  if (value === null || value === undefined) return '-'
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  return value.toLocaleString('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

app.config.globalProperties.$numberFormat = (value: number | string | undefined | null) => {
  if (value === null || value === undefined) return '-'
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  return value.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

app.config.globalProperties.$media = import.meta.env.VITE_MEDIA_BASE || ''

if (isDevelopment && config.enableDebug) {
  console.log('✅ Application mounted successfully')
}

const options: PluginOptions = {
  draggable: false,
  closeOnClick: false,
  position: POSITION.BOTTOM_RIGHT,
}
app.use(Toast, options)
